import { createFileRoute } from '@tanstack/react-router';
import { head } from '@pages/ContactPage.head';
import { ContactPage } from '@pages/ContactPage';

export const Route = createFileRoute('/contact')({
  component: ContactPage,
  head: () => head,
});
